import type { webHints as webHintsEn } from "../../en/webHints";
import { common } from "./common";
import { destination } from "./destination";
import { trip } from "./trip";
import { inspiration } from "./inspiration";
import { guide } from "./guide";

// Nápovědy polí šesti editorů (řez 10, F9.6). Měřidlo nápověd slovník načítá pod jménem `webHints`.
export const webHints: typeof webHintsEn = { common, destination, trip, inspiration, guide };
